module.exports = __webpack_public_path__ + "static/media/THSarabunNew.4c9a6e3d.ttf";